<template>
  <svg width="24px" height="24px"
       viewBox="0 0 24 24" version="1.1"
       xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>atoms/icons/24x24/search/black</title>
    <g id="atoms/icons/24x24/search/black" stroke="none"
       stroke-width="1"
       fill-rule="evenodd">
      <path d="M9.8,2.4 C13.7764502,2.4 17,5.6235498 17,9.6 C17,11.4016714 16.3382492,13.0487827 15.2445483,14.3115331 L21.1455844,20.2142136 C21.4580038,20.526633 21.4580038,21.033165 21.1455844,21.3455844 C20.833165,21.6580038 20.326633,21.6580038 20.0142136,21.3455844 L14.0670428,15.399928 C12.8728928,16.2799434 11.3971793,16.8 9.8,16.8 C5.8235498,16.8 2.6,13.5764502 2.6,9.6 C2.6,5.6235498 5.8235498,2.4 9.8,2.4 Z M9.8,4 C6.7072054,4 4.2,6.5072054 4.2,9.6 C4.2,12.6927946 6.7072054,15.2 9.8,15.2 C12.8927946,15.2 15.4,12.6927946 15.4,9.6 C15.4,6.5072054 12.8927946,4 9.8,4 Z" id="Combined-Shape"
            fill-rule="nonzero"></path>
    </g>
  </svg>
</template>
<script setup>
// dummy comment to surpress rollup build errors with dynamic imports
// if the file doesn't contain a script tag with content, the build fails.
</script>
